import queryString from 'query-string'
import React from 'react'
import { useStore } from 'react-redux'
import { sendMsgAction } from '../../../utils/actions'
import { cleanParams, updateInitialStateWithParams, validateParams } from '../common/fns'
import PageView from '../containers/PageView'
import {
  postCalculation,
  fieldSwitchSubAppAction as setInitialState,
} from '../store/actions/calculation.action'
import { inputSlice } from '../store/slices/input.slice'
import { loadAppState } from '../store/store'

function App() {
  const { dispatch } = useStore()

  const search = window.location.search
  let errors = []

  const rawParams = search ? queryString.parse(search) : {}
  const params = cleanParams(rawParams)

  const input = loadAppState()?.calculation?.input ?? inputSlice.getInitialState()

  if (Object.values(params).length === 0) {
    dispatch(postCalculation(input))
  } else {
    errors = validateParams(params)

    if (errors.length === 0) {
      const myInitial = updateInitialStateWithParams(params)

      dispatch([setInitialState(myInitial), postCalculation(myInitial)])
    } else {
      dispatch([
        sendMsgAction({
          description:
            'The URL you used to load this page contains some unexpected parameters. The application will instead use its default settings.',
        }),
        postCalculation(input),
      ])
    }
  }

  return <PageView />
}

export default App
